import logo from "../../assets/images/favicon.png";
export const printComponent = (componentId) => {
  var mywindow = window.open("", "PRINT", "height=1200,width=1170");

  mywindow.document.write("<html><head>");
  mywindow.document.write("<style>");
  mywindow.document.write(
    "@page { size: 8.27in 11.69in; margin: 7.8mm 5.08mm 7.8mm 5.08mm; }"
  );
  mywindow.document.write("* { font-family: Arial, sans-serif; margin: 0px}");
  mywindow.document.write(
    " .footer { position: fixed; bottom: 0; left: 0; width: 100%; text-align: center; font-size: 12px; padding: 5px 0;} .footer img { height: 20px; vertical-align: middle; margin-left: 5px; }"
  );
  mywindow.document.write("</style>");
  mywindow.document.write(`<title> Print </title>`);
  mywindow.document.write("</head><body >");
  mywindow.document.write(document.getElementById(componentId).innerHTML);
  mywindow.document.write(`
    <div class="footer">
      Powered by BuildTrust<img src=${logo} alt="Logo">
    </div>
  `);
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/

  setTimeout(function () {
    mywindow.print();
    mywindow.close();
  }, 2000);
  return true;
};
